<template>
  <div v-if="visible">
    <slot
    ></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true
    }
  },
  computed: {
    theme() {
      try {
        return this.$theme.getTheme()
      } catch (error) {
        return ''
      }
    }
  },
  watch: {
    theme() {
      if (weex.config.env.platform != 'iOS') {
        this.visible = false
        setTimeout(() => (this.visible = true))
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// index.vue?70156ac9